module.exports = __webpack_public_path__ + "img/ban-smoking.ad97bbbe.svg";